import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { IRichiesta } from '../interfaces/IRichiesta';

@Component({
  selector: 'app-note-modal',
  templateUrl: './note-modal.component.html',
  styleUrls: ['./note-modal.component.css']
})
export class NoteModalComponent implements OnInit {

  notaValidazione: string
  readOnly: boolean = false
  richiesta: IRichiesta

  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef
  ) {
    this.readOnly = this.config.data.readOnly
    this.richiesta = this.config.data.richiesta
  }

  ngOnInit() {

  }

  /**
   * dal bottone di conferma passando il valore della nota inserita 
   */
  sendRichiestaToAggiudicatario() {
    if (this.ref) {
      this.ref.close(this.notaValidazione)
    }
  }

}
